import React from "react";
import { UserDashboard } from "./UserDashboard";
import { GuestDashboard } from "./GuestDashboard";
import { User } from "lib/auth";

interface DashboardProps {
  user?: User;
}

export const Dashboard = ({ user }: DashboardProps): React.ReactElement => {
  if (user) {
    return <UserDashboard user={user} />;
  }

  return <GuestDashboard />;
};
